import { PosElapsedTimeComponent } from './pos-elapsed-time.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [PosElapsedTimeComponent],
  imports: [CommonModule],
  exports: [PosElapsedTimeComponent],
})
export class PosElapsedTimeModule {}
